import React, { useEffect, useState } from "react";
import "../Style/Pages/RiderManagement.css";
import eye from "../Assets/rider/eye.svg";
import search from "../Assets/rider/search.svg";
import Select, { components } from "react-select";
import filter from "../Assets/rider/filter.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getWithTokenAPI } from "../Util/Api.js";
import { TableSkeleton } from "../Component/Skeleton.jsx";
import { toast } from "react-toastify";
const RiderManagement = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const statusFromUrl = searchParams.get("status") || "";
  const [tpage, setTpage] = useState(4);
  const [page, setPage] = useState(1);
  const [ridedata, setRidedata] = useState([]);
  console.log(ridedata, 'ridedataridedata')
  const filteroptions = [
    { value: "", label: "All" },
    { value: "CREATED", label: "Created" },
    { value: "ASSIGNED", label: "Assigned" },
    { value: "EN_ROUTE", label: "En Route" },
    { value: "ARRIVED", label: "Arrived" },
    { value: "STARTED", label: "Started" },
    { value: "DROPED", label: "Dropped" },
    { value: "COMPLETED", label: "Completed" },
    { value: "CANCELLED", label: "Cancelled" },
  ];
  const [status, setStatus] = useState(statusFromUrl);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setStatus(statusFromUrl);
  }, [statusFromUrl]);
  useEffect(() => {
    const fetchrides = async () => {
      try {
        setLoading(true);

        const invalidParams = Array.from(searchParams.keys()).some(
          (key) => key !== "status"
        );

        if (invalidParams) {
          setRidedata([]);
          setTpage(0);
          toast.error("Invalid URL Parameters Detected");
          return;
        }
        const res = await getWithTokenAPI(
          token,
          `/rider-booking/list?page=${page}&limit=10&search=${searchText}&status=${status}`,
        );
        setRidedata(res?.data?.data);
        setTpage(Math.ceil(res?.data?.total / 10));
      } catch {
        console.log("Error in fetching Limit Api");
      } finally {
        setLoading(false);
      }
    };
    fetchrides();
  }, [token, searchText, status, page]);
  const tableHead = [
    "RideID",
    "Customer",
    "Rider",
    "Fare",
    "From",
    "To",
    "Status",
    "Detail",
    "Payment",
  ];
  function formatToINR(amount) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(amount);
  }

  const SingleValueWithLabel = (label) => (props) => (
    <components.SingleValue {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-value">{props.data.label}</span>
    </components.SingleValue>
  );

  const PlaceholderWithLabel = (label) => (props) => (
    <components.Placeholder {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-placeholder">All</span>
    </components.Placeholder>
  );
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "36px",
      height: "36px",
      // width: "180px",
      minWidth: "180px",
      maxWidth: "fitContent",
      border: "none",
      borderRadius: "14px",
      paddingLeft: "27px",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(1,58,40,0.15)" : "none",
      backgroundColor: "white",
      cursor: "pointer",
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
      height: "36px",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#555",
      fontSize: "14px",
      fontWeight: "500",
      margin: 0,
      lineHeight: "36px",
      top: "0",
      transform: "none",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#888",
      fontSize: "14px",
      fontWeight: "500",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#666",
      padding: "0 10px",
      "&:hover": {
        color: "#333",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#013A28"
        : state.isFocused
          ? "#02543a53"
          : "white",
      color: state.isSelected ? "white" : "#333",
      cursor: "pointer",
      ":hover": {
        backgroundColor: state.isSelected ? "#013A28" : "#02543a53",
      },
    }),

    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      zIndex: 9999,
    }),

    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
      overflowY: "auto",

      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#013a2826",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#013a2855",
        borderRadius: "3px",
      },
    }),
  };

  return (
    <div className="ridermanagement">
      <div className="riderpagetop">
        <span className="ridertophead">Ride Management</span>
        <div className="ridertopfilter">
          <div className="searchbar">
            <img src={search} alt="search" />
            <input
              className="searchinput"
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(1);
              }}
            />
          </div>
        </div>
      </div>

      <div className="status-tabs-container">
        {filteroptions.map((option) => (
          <div
            key={option.value}
            className={`status-tab ${status === option.value ? "active" : ""}`}
            onClick={() => {
              setStatus(option.value);
              setPage(1);
              if (option.value) {
                setSearchParams({ status: option.value });
              } else {
                setSearchParams({});
              }
            }}
          >
            {option.label}
          </div>
        ))}
      </div>
      {loading ? (
        <TableSkeleton
          rows={8}
          columns={[
            "RideId",
            "Customer Name",
            "Driver Name",
            "Price",
            "PickUp Address",
            "Drop Address",
            "Status",
            "Detail",
            "Payment",
          ]}
        />
      ) : (
        <div className="riderpagebottom">
          <table className="riderpagetable">
            <thead>
              <tr>
                {tableHead.map((head, index) => (
                  <th key={index}>{head}</th>
                ))}
              </tr>
            </thead>

            {ridedata.length > 0 ? (
              <>
                <tbody>
                  {ridedata.map((row, index) => (
                    <tr key={index}>
                      <td
                        style={{ fontWeight: "500", cursor: "pointer" }}
                        onClick={() => navigate(`/admin/ridestrack/${row?._id}`)}
                      >
                        {row?.Ride_ID}
                      </td>
                      <td
                        style={{ fontWeight: "500", cursor: "pointer" }}
                        onClick={() => navigate(`/admin/customerdata/user/${row?.customer?._id}`)}
                      >
                        {row?.customer?.name}
                      </td>
                      <td
                        style={{ fontWeight: "500", cursor: "pointer" }}
                        onClick={() => navigate(`/admin/driversdata/driver/${row?.driver?._id}`)}
                      >
                        {row?.driver?.name}
                      </td>
                      {/* <td>{row?.customer?.name}</td>
                      <td>{row?.driver?.name}</td> */}
                      <td>{formatToINR(row?.price)}</td>
                      <td>{row?.pickupAddress}</td>
                      <td>{row?.dropAddress}</td>

                      <td>
                        <span
                          className={`status-pill ${row?.status.replace(" ", "").toLowerCase()}`}
                        >
                          {row?.status}
                        </span>
                      </td>

                      <td
                        className="eye"
                        style={{ textAlign: "center" }}
                        onClick={() => navigate(`/admin/ridestrack/${row?._id}`)}
                      >
                        <img src={eye}></img>
                      </td>
                      <td>
                        {/* <td className="paymentcell"> */}
                        <span className="payment-pill">Paid</span>
                        {/* <small>{row?.paymentType}</small> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="9">
                      {tpage > 1 && (
                        <div className="pagination">
                          {page > 1 && (
                            <button
                              className="page-btn"
                              onClick={() => setPage((page) => page - 1)}
                            >
                              ‹
                            </button>
                          )}
                          {page > 1 && (
                            <button
                              className="page-btn"
                              onClick={() => setPage(1)}
                            >
                              1
                            </button>
                          )}
                          {page === tpage && (
                            <span className="page-dots">…</span>
                          )}
                          <button className="page-btn pgnoactive">
                            {page}
                          </button>

                          {page !== tpage && (
                            <span className="page-dots">…</span>
                          )}

                          {page !== tpage && (
                            <button
                              className="page-btn"
                              onClick={() => setPage(tpage)}
                            >
                              {tpage}
                            </button>
                          )}

                          {page < tpage && (
                            <button
                              className="page-btn"
                              onClick={() => setPage((page) => page + 1)}
                            >
                              ›
                            </button>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                </tfoot>
              </>
            ) : (
              <tr>
                <td colSpan={9}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "40px 0",
                      color: "#6b7280",
                    }}
                  >
                    <span style={{ fontSize: "18px", fontWeight: "500" }}>
                      No Rides Available
                    </span>

                    <span style={{ fontSize: "14px", marginTop: "4px" }}>
                      There are currently no rides to display.
                    </span>
                  </div>
                </td>
              </tr>
            )}
          </table>
        </div>
      )}
    </div>
  );
};

export default RiderManagement;
